// extracted by mini-css-extract-plugin
export default {"card":"c-e_eb","card_styleDefault":"c-e_ec","card_styleRed":"c-e_ee"};